import { Identifiable, Planzone, Resource, ResourceTypes } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedPlanzoneResource, Linker } from "../linkers/types";

function saveMaterialResourceInPlanzone(
  httpClient: HttpClient,
  linker: Linker,
) {
  return (planzone: Identifiable<Planzone>, resource: Resource) =>
    httpClient
      .sendHttpRequest<LinkedPlanzoneResource>({
        endpoint: `/resources`,
        method: HttpMethods.POST,
        data: {
          name: resource.name,
          description: resource.description,
          type: ResourceTypes.MATERIAL,
          planzone: `planzones/${planzone.uuid}`,
        },
      })
      .then(linker.linkResource);
}

export { saveMaterialResourceInPlanzone };
